export default __webpack_public_path__ + "static/media/lupaBranca.c6276443.svg";